import { render, staticRenderFns } from "./OverlayNavigation.vue?vue&type=template&id=aaa4bef8&scoped=true&"
import script from "./OverlayNavigation.vue?vue&type=script&lang=js&"
export * from "./OverlayNavigation.vue?vue&type=script&lang=js&"
import style0 from "./OverlayNavigation.vue?vue&type=style&index=0&id=aaa4bef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa4bef8",
  null
  
)

export default component.exports